import { api } from '../lib/api';

/** Moving files by dragging them onto a folder (a row, the tree or a breadcrumb). */
export const DRAG_TYPE = 'application/x-dugzi-drive';

export function startDrag(e: React.DragEvent, ids: string[], label: string) {
  e.dataTransfer.setData(DRAG_TYPE, JSON.stringify(ids));
  e.dataTransfer.setData('text/plain', label);
  e.dataTransfer.effectAllowed = 'move';
  const ghost = document.createElement('div');
  ghost.className = 'drag-ghost';
  ghost.textContent = ids.length > 1 ? `${ids.length} items` : label;
  document.body.appendChild(ghost);
  e.dataTransfer.setDragImage(ghost, 12, 12);
  setTimeout(() => ghost.remove(), 0);
}

export async function dropMove(dt: DataTransfer, folderId: string, toast: { show(m: string): unknown }): Promise<boolean> {
  let ids: string[] = [];
  try { ids = JSON.parse(dt.getData(DRAG_TYPE) || '[]'); } catch { return false; }
  ids = ids.filter((i) => i !== folderId);
  if (!ids.length) return false;
  try {
    const r = await api<{ moved: number }>('/api/nodes/move', { body: { ids, parentId: folderId } });
    toast.show(r.moved === 1 ? 'Moved.' : `${r.moved} items moved.`);
    return true;
  } catch (e) {
    toast.show((e as Error).message);
    return false;
  }
}
